export const DATA_HOOKS = {
    label: 'dropdown-label',
    coreDropdown: 'core-dropdown',
    base: 'dropdown-base',
    nativeSelect: 'native-select',
    baseText: 'dropdown-base-text',
    placeholderOption: 'placeholder-option',
    errorTooltip: 'dropdown-error-tooltip',
    option: 'dropdown-option',
    icon: 'dropdown-option-icon',
    suffix: 'dropdown-option-suffix',
    loader: 'dropdown-loader',
};
export const DATA_ATTRIBUTES = {
    error: 'data-error',
};
//# sourceMappingURL=constants.js.map